import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "cron" ]

  connect() {
    this.toggleCron({ currentTarget: this.element.querySelector('input[name="schedule_toggle"]:checked') })
  }

  toggleCron(event) {
    if (event.currentTarget.value === 'yes') {
      this.cronTarget.classList.remove('hidden')
    } else {
      this.cronTarget.classList.add('hidden')
      const cronInput = this.cronTarget.querySelector('input[data-cron-scheduler-target="hiddenInput"]')
      if (cronInput) {
        cronInput.value = ''
      }
    }
  }
}
